<template v-once>
    <div v-if="isLoaded" id="navbar">
        <nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-static-top navbar-dark bg-gradient-x-grey-blue navbar-border"  v-bind:class="{ 'fixed-top': isSmallScreen, 'navbar-brand-center': !isSmallScreen }"
             data-nav="brand-center">
            <div class="navbar-wrapper">
                <div class="navbar-header">
                    <ul class="nav navbar-nav flex-row">
                        <li class="nav-item mobile-menu d-md-none mr-auto">
                            <a class="nav-link nav-menu-main menu-toggle hidden-xs"
                                @click="menuShowHide()"
                               href="#"><i class="ft-menu font-large-1"></i></a>
                        </li>
                        <li class="nav-item">
                            <div class="navbar-brand">
                                <img class="brand-logo"
                                     src="images/logo_isend_mini.png"
                                     alt="logo">
                            </div>
                        </li>
                        <li class="nav-item d-md-none">
                            <a class="nav-link open-navbar-container"
                               data-toggle="collapse"

                               data-target="#navbar-mobile"><i class="fa fa-ellipsis-v"></i></a>
                        </li>
                    </ul>
                </div>

                <div class="navbar-container content">
                    <div class="navbar-collapse collapse"
                         id="navbar-mobile">
                        <ul class="nav navbar-nav mr-auto float-left">
                            <li class="nav-item d-none d-md-block"
                                @click="menuShowHide()">
                                <a class="nav-link nav-menu-main menu-toggle hidden-xs"
                                   href="#"><i class="ft-menu"></i></a>
                            </li>
                        </ul>

                        <ul class="nav navbar-nav float-right">
                            <li class="dropdown dropdown-language nav-item"
                                v-if="bclientes.length>=1">
                                <a class="dropdown-toggle nav-link"
                                   id="dropdown-bcliente"
                                   href="#"
                                   data-toggle="dropdown"
                                   aria-haspopup="true"
                                   aria-expanded="false">{{ bcliente_active.nome_bcliente }}</a>
                                <div class="dropdown-menu"
                                     aria-labelledby="dropdown-bcliente">
                                    <a v-for="item in bclientes"
                                       @click="setBclienteInterno(item.bcliente.bcliente_id)"
                                       class="dropdown-item"
                                       href="#"> <span class="fa fa-building"></span> {{ item.bcliente.cd }} - {{ item.bcliente.nome }} </a>
                                </div>
                            </li>

                            <li class="dropdown dropdown-language nav-item"
                                v-if="unidades.length>=1">
                                <a class="dropdown-toggle nav-link"
                                   id="dropdown-unidade"
                                   href="#"
                                   data-toggle="dropdown"
                                   aria-haspopup="true"
                                   aria-expanded="false">{{ unidade_active.descr_unidade }}</a>
                                <div class="dropdown-menu"
                                     aria-labelledby="dropdown-unidade">
                                    <a v-for="item in unidades"
                                       @click="setUnidadeInterno(item.unidade.unidade_id)"
                                       class="dropdown-item"
                                       href="#"> <span class="fa fa-building"></span> {{ item.unidade.cd }} - {{ item.unidade.descr }}</a>
                                </div>
                            </li>

                            <notification>
                            </notification>

                            <li class="dropdown dropdown-user nav-item">
                                <a class="dropdown-toggle nav-link dropdown-user-link"
                                   href="#"
                                   data-toggle="dropdown">
                                    <span class="avatar avatar-online">
                                        <b-img v-bind:src="url_img_profile"
                                               fluid />
                                    </span>
                                    <span class="user-name">
                                    </span>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item"
                                       href="#"><i class="ft-mail"></i>{{ user.email }}</a>

                                    <router-link to="/usuarioconf"
                                                 tag="li"
                                                 v-if="getPermission('usuarioconf.index')">
                                        <a class="dropdown-item"
                                           href="/usuarioconf"><i class="ft-user"></i>Meus dados</a>
                                    </router-link>

                                    <router-link to="/conta"
                                                 tag="li"
                                                 v-if="getPermission('conta.index')">
                                        <a class="dropdown-item"
                                           href="/conta"><i class="ft-settings"></i> Conta</a>
                                    </router-link>

                                    <a v-if="user.bcliente_active.b_config_blogistic.link_suporte==1"
                                       class="dropdown-item"
                                       href="https://suporteitrackbrasil.zendesk.com/hc/pt-br/requests/new"
                                       target="_blank"><i class="ft-message-square"></i> Suporte</a>
                                    <div class="dropdown-divider"></div>
                                        <a v-on:click=logout()>
                                            <button class="dropdown-item"
                                                    type="submit"><i class="ft-power"></i>Sair</button>
                                        </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>

        <div id="sticky-wrapper" class="sticky-wrapper" style="height: 90px;" v-if="isMenuShowHide">
            <div class="header-navbar navbar-expand-sm navbar navbar-horizontal navbar-fixed navbar-light navbar-without-dd-arrow navbar-shadow menu-border navbar-brand-center"
                 role="navigation"
                 data-menu="menu-wrapper"
                 data-nav="brand-center"
                >
                <!-- Horizontal menu content-->
                <div class="navbar-container main-menu-content"
                     data-menu="menu-container" style="color: #404E67 !important">
                    <ul class="nav navbar-nav"
                        id="main-menu-navigation"
                        data-menu="menu-navigation">

                        <li class="dropdown nav-item p-1">
                            <div @click="closeMenuMobile()">
                                <router-link to="/dashboard"
                                             tag="li"
                                             ><a class="text-muted"><i class="ft-bar-chart"></i><span>Dashboard</span></a>
                                </router-link>
                            </div>
                        </li>

                        <li class="dropdown nav-item p-1">
                            <div @click="closeMenuMobile()">
                                <router-link to="/pessoa"
                                    tag="li"
                                    v-if="getPermission('pessoa.index')">
                                    <a class="text-muted"><i class="ft-users"></i><span>Cliente</span></a>
                                </router-link>
                            </div>
                        </li>

                        <dropdown
                            id="menu-conferencia"
                            :close-on-click="true"
                            v-if="conference_module && (getPermission('conferencia_volume.index') || getPermission('recebimento_manifesto.receber_notas') || getPermission('consulta_pendencia.index') || getPermission('inventario.index'))"
                            class="p-1"
                        >
                            <template slot="btn">
                                <i class="ft-box"></i>&nbsp;<span class="bp-dropdown__btn">
                                    Conferência
                                </span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12">
                                        <div class="list-group list-group-flush">
                                            <router-link
                                                to="/recebernotasmanifesto"
                                                tag="li"
                                                v-if="getPermission('recebimento_manifesto.receber_notas')"
                                            >
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div @click="closeMenuMobile()" class="media">
                                                            <div class="mr-1">
                                                                <i class="fa fa-download"></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">
                                                                    Recebimento Notas via Manifesto
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link
                                                to="/conferenciavolume"
                                                tag="li"
                                                v-if="getPermission('conferencia_volume.index') && conference_module"
                                            >
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div @click="closeMenuMobile()" class="media">
                                                            <div class="mr-1">
                                                                <i class="ft-box"></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">
                                                                    Conferência de Volumes
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link
                                                to="/consultapendencia"
                                                tag="li"
                                                v-if="getPermission('consulta_pendencia.index') && conference_module"
                                            >
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div @click="closeMenuMobile()" class="media">
                                                            <div class="mr-1">
                                                                <i class="ft-bar-chart"></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Pendências</p>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link
                                                to="/inventario"
                                                tag="li"
                                                v-if="getPermission('inventario.index') && conference_module"
                                            >
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div @click="closeMenuMobile()" class="media">
                                                            <div class="mr-1">
                                                                <i class="fa fa-book"></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Inventário</p>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown>

                        <li class="dropdown nav-item p-1"
                            data-menu="dropdown"
                            v-show="getPermission('gerardoc.index')">
                            <div @click="closeMenuMobile()">
                                <router-link to="/gerardoc"
                                             tag="li"
                                             v-if="getPermission('gerardoc.index')">
                                        <a class="text-muted"><i class="ft-book"></i><span>Gerar Doc</span></a>
                                </router-link>
                            </div>
                        </li>

                        <li class="dropdown nav-item p-1"
                            data-menu="dropdown"
                            v-show="getPermission('cte.index')">
                            <div @click="closeMenuMobile()">
                                <router-link to="/cte"
                                             tag="li"
                                             v-if="getPermission('cte.index')">
                                        <a class="text-muted"><i class="fa fa-file-text-o"></i><span>Consulta Docs</span></a>
                                </router-link>
                            </div>
                        </li>

                        <li class="dropdown nav-item p-1"
                            data-menu="dropdown"
                            v-show="getPermission('expedicao.index')">
                            <router-link to="/expedicao"
                                         tag="li"
                                         v-if="getPermission('expedicao.index')"
                                         >
                                         <div @click="closeMenuMobile()">
                                             <a class="text-muted"><i class="fa fa-sign-out"></i><span>Expedição</span></a>
                                         </div>
                            </router-link>
                        </li>
                        <li class="dropdown nav-item p-1"
                            data-menu="dropdown"
                            v-show="getPermission('frota.index') && b_plano.is_free==2">
                            <div @click="closeMenuMobile()">
                                <router-link to="/frota"
                                             tag="li"
                                             v-if="getPermission('frota.index') && b_plano.is_free==2">
                                        <a class="text-muted"><i class="fa fa-truck"></i><span>Frota</span></a>
                                </router-link>
                            </div>
                        </li>
                        <li class="dropdown nav-item p-1"
                            data-menu="dropdown"
                            v-show="getPermission('downloadnotfis.index')">
                            <div @click="closeMenuMobile()">
                                <router-link to="/downloadnotfis"
                                             tag="li"
                                             v-if="getPermission('downloadnotfis.index')">
                                        <a class="text-muted"><i class="fa fa-download"></i><span>Download Notfis</span></a>
                                </router-link>
                            </div>
                        </li>

                        <dropdown id="menu-operacao"
                                  :close-on-click="true"
                                  v-if="getPermission('montagemcarga.index')"
                                  class="p-1">
                            <template slot="btn">
                                <i class="fa fa-cubes"></i>&nbsp;<span class="bp-dropdown__btn">Montagem de Carga</span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/montagemcarga"
                                                         tag="li"
                                                         v-if="getPermission('montagemcarganfe.index')"
                                                        >
                                                <a >
                                                    <span class="list-group-item no-border">
                                                        <div @click="closeMenuMobile()" class="media">
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Montagem por NF</p>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/montagemcargacte"
                                                         tag="li"
                                                         v-if="getPermission('montagemcargacte.index')">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div  @click="closeMenuMobile()" class="media">
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Montagem por CTE</p>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown>
                        <dropdown id="menu-operacao"
                                  :close-on-click="true"
                                  v-if="b_plano.is_free==2 && getPermission('cte.menu')"
                                  class="p-1">
                            <template slot="btn">
                                <i class="fa fa-id-card-o"></i>&nbsp;<span class="bp-dropdown__btn">CTE</span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/cotacao"
                                                         tag="li"
                                                         v-if="getPermission('cotacao.index')">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-book'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Cotação</p>
                                                                <small>Faz cotação de transporte</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/pedido"
                                                         tag="li"
                                                         v-if="getPermission('pedido.index')">
                                                <a to="/pedido">
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-book'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Pedido</p>
                                                                <small>Gera pedido</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/gestaocarga"
                                                         tag="li"
                                                         v-if="getPermission('gestaocarga.index')">
                                                <a to="/pedido">
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-cubes'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Gestao de Carga</p>
                                                                <small>Gerenrnciamento de cargas</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/consultanfe"
                                                         tag="li"
                                                         v-if="getPermission('exportacaodocfiscal.index')">
                                                <a to="/pedido">
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-file-text-o'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Consultar NFe</p>
                                                                <small>Consulta de notas fiscais</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/consultalognfe"
                                                         tag="li"
                                                         v-if="getPermission('arquivoedientradalog.index')">
                                                <a to="/pedido">
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-file-text-o'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Consultar Log NFes</p>
                                                                <small>Consulta de log de notas fiscais</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/associar"
                                                         tag="li"
                                                         v-if="getPermission('associar.index')">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-bookmark'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Associar Documentos</p>
                                                                <small>Associar documentos a unidade de carga</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/manutencao"
                                                         tag="li"
                                                         v-if="getPermission('manutencaonf.index')"
                                                         >
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-file-text-o'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Manutenção de Notas fiscais</p>
                                                                <small>Manutenção de Notas fiscais</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/gerarcteassociado"
                                                         tag="li"
                                                         v-if="getPermission('gerarcteassociado.index')">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-clipboard'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Gerar CTE Associado</p>
                                                                <small>Gera CTE de documentos previamente associados</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/gerarctelote"
                                                         tag="li"
                                                         v-if="getPermission('gerarctelote.index')">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-activity'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Gerar CTE Lote</p>
                                                                <small>Gera CTE em lote a partir de Unidadede Carga</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/ctelote"
                                                         tag="li"
                                                         v-if="getPermission('gerarcte.index')">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-download'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Gerar CTE Unitário em Lote</p>
                                                                <small>Gera CTE em lote de NF's</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/ctecomplementar"
                                                         tag="li"
                                                         v-if="getPermission('ctecomplementar.index')">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-upload-cloud'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Gerar CTE Complementar</p>
                                                                <small>Baseado em XML de CTE ( Migração )</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/cteveiculo"
                                                         tag="li"
                                                         v-if="getPermission('cteveiculo.index')">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-car'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Gerar CTE Veículo</p>
                                                                <small>CTE Veículo em lote</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                          <router-link to="/gerenciamentotransporte"
                                                       tag="li"
                                                       v-if="getPermission('gerenciamentotransporte.index')">
                                            <a>
                                                <span class="list-group-item no-border">
                                                    <div class="media">
                                                        <div class="mr-1">
                                                            <i class='fa fa-car'></i>
                                                        </div>
                                                        <div class="media-body">
                                                            <p class="mt-0 mb-0">Gerenciamento transporte</p>
                                                            <small>Gestão da operação</small>
                                                        </div>
                                                    </div>
                                                </span>
                                            </a>
                                          </router-link>

                                          <router-link to="/consultaciot"
                                                       tag="li"
                                                       v-if="getPermission('ciot.index')">
                                            <a>
                                                <span class="list-group-item no-border">
                                                    <div class="media">
                                                        <div class="mr-1">
                                                            <i class='ft-align-justify'></i>
                                                        </div>
                                                        <div class="media-body">
                                                            <p class="mt-0 mb-0">Consulta Ciot</p>
                                                            <small>Consultas de Ciot</small>
                                                        </div>
                                                    </div>
                                                </span>
                                            </a>
                                          </router-link>

                                          <router-link to="/inclusaoocorrencia"
                                                       tag="li"
                                                       v-if="getPermission('inclusaoocorrencia.index')">
                                            <a>
                                                <span class="list-group-item no-border">
                                                    <div class="media">
                                                        <div class="mr-1">
                                                            <i class='fa fa-exclamation-triangle'></i>
                                                        </div>
                                                        <div class="media-body">
                                                            <p class="mt-0 mb-0">Ocorrências</p>
                                                            <small>Incluir Ocorrência</small>
                                                        </div>
                                                    </div>
                                                </span>
                                            </a>
                                          </router-link>

                                          <router-link to="/posicaonotafiscal"
                                                       tag="li"
                                                       v-if="getPermission('posicaonf.index')">
                                            <a>
                                                <span class="list-group-item no-border">
                                                    <div class="media">
                                                        <div class="mr-1">
                                                            <i class='fa fa-file-text'></i>
                                                        </div>
                                                        <div class="media-body">
                                                            <p class="mt-0 mb-0">Posição nota Fiscal</p>
                                                            <small>Informações da NF</small>
                                                        </div>
                                                    </div>
                                                </span>
                                            </a>
                                          </router-link>

                                            <dropdown :trigger="'hover'"
                                                      :role="'sublist'"
                                                      :align="'right'"
                                                      :close-on-click="true">
                                                <template slot="btn">
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-code'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">XML</p>
                                                                <small>Importação</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </template>
                                                <template slot="body">
                                                    <router-link to="/xmlnfe"
                                                                 tag="li"
                                                                 v-if="getPermission('xmlnfe.index')">
                                                        <a>
                                                            <span class="list-group-item no-border">NFE</span>
                                                        </a>
                                                    </router-link>

                                                    <router-link to="/xmlcte"
                                                                 tag="li"
                                                                 v-if="getPermission('xmlcte.index')">
                                                        <a>
                                                            <span class="list-group-item no-border">CTE</span>
                                                        </a>
                                                    </router-link>

                                                </template>
                                            </dropdown>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown>

                        <dropdown id="menu-manifesto"
                                  :close-on-click="true"
                                  class="p-1"
                                  v-if="getPermission('manifesto.menu')">
                            <template slot="btn">
                                <i class="ft-list"></i>&nbsp;<span class="bp-dropdown__btn">Manifesto</span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/gerarmdfe"
                                                         tag="li"
                                                         v-if="getPermission('gerarmdfe.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-mail'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">MDFE</p>
                                                                <small>Gerar MDFE</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/mdfe"
                                                         tag="li"
                                                         v-if="getPermission('mdfe.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-inbox'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Consulta de MDFE</p>
                                                                <small>Consulta, cancelamento, encerramento, liberação</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/siscarga"
                                                         tag="li"
                                                         v-if="getPermission('siscarga.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-sitemap'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Siscarga</p>
                                                                <small>Gerar arquivo para integração</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/synchro"
                                                         tag="li"
                                                         v-if="getPermission('synchro.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item mega-menu-bg-blue1">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-share'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Synchro</p>
                                                                <small>Envia dados de transporte</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown>

                        <dropdown id="menu-financeiro"
                                  v-if="b_plano.is_free==2 && getPermission('financeiro.menu')"
                                  class="p-1">
                            <template slot="btn">
                                <i class="fa fa-money"></i>&nbsp;<span class="bp-dropdown__btn">Financeiro</span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                        <router-link to="/faturadespesa"
                                                         tag="li"
                                                         v-if="getPermission('faturadespesa.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-log-in'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Fatura Despesa</p>
                                                                <small>Fatura Despesa</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/receita"
                                                         tag="li"
                                                         v-if="getPermission('receita.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-log-in'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Receita</p>
                                                                <small>Gestão financeira - Receita</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/despesa"
                                                         tag="li"
                                                         v-if="getPermission('despesa.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-log-out'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Despesa</p>
                                                                <small>Gestão financeira - Despesa</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/prefaturareceita"
                                                         tag="li"
                                                         v-if="getPermission('gerarprefaturareceita.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-log-in'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Pré-Fatura - Receita</p>
                                                                <small>Pré-Fatura</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/prefaturadespesa"
                                                         tag="li"
                                                         v-if="getPermission('gerarprefaturadespesa.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-log-out'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Pré-Fatura - Despesa</p>
                                                                <small>Pré-Fatura </small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/prefaturadespesaagregado"
                                                         tag="li"
                                                         v-if="getPermission('gerarprefaturadespesaagregado.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-log-out'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Pré-Fatura - Despesa Agregado</p>
                                                                <small>Pré-Fatura Despesa Agregado</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/gerarfatura"
                                                         tag="li"
                                                         v-if="getPermission('gerarfatura.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-external-link'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Fatura</p>
                                                                <small>Gera Fatura de CtE</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/fatura"
                                                         tag="li"
                                                         v-if="getPermission('fatura.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-align-justify'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Fatura</p>
                                                                <small>Consulta fatura</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/consultaprefaturareceita"
                                                         tag="li"
                                                         v-if="getPermission('gerarprefaturareceita.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-align-justify'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Receita</p>
                                                                <small>Consulta pré fatura receita</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/consultaprefaturadespesa"
                                                         tag="li"
                                                          v-if="getPermission('prefaturadespesa.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-align-justify'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Despesa</p>
                                                                <small>Consulta pré fatura despesa</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown>

                        <dropdown :close-on-click="false"
                                  v-if="b_plano.is_free==2 && getPermission('cadastro.menu')"
                                  class="p-1">
                            <template slot="btn">
                                <i class="fa fa-address-book-o"></i>&nbsp;<span class="bp-dropdown__btn">Cadastros</span>
                            </template>
                            <template slot="body">
                                <ul style="padding-inline-start: 5px">
                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn">
                                            <span class="list-group-item no-border">Gerais</span>
                                        </template>

                                        <template slot="body">
                                            <router-link to="/pais"
                                                         tag="li"
                                                         v-if="getPermission('pais.index')">
                                                <a >
                                                    <span class="list-group-item no-border">País</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/uf"
                                                         tag="li"
                                                         v-if="getPermission('uf.index')">
                                                <a to="/uf">
                                                    <span class="list-group-item no-border">UF</span>
                                                </a>
                                            </router-link>

                                          <router-link to="/percursouf"
                                                       tag="li"
                                                       v-if="getPermission('percursouf.index')">
                                            <a to="/percursouf">
                                              <span class="list-group-item no-border">UFs do percurso</span>
                                            </a>
                                          </router-link>

                                            <router-link to="/municipio"
                                                         tag="li"
                                                         v-if="getPermission('municipio.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Municipio</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/moeda"
                                                         tag="li"
                                                         v-if="getPermission('moeda.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Moeda</span>
                                                </a>
                                            </router-link>
                                            <router-link to="/feriados"
                                                         tag="li"
                                                         v-if="getPermission('feriado.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Feriados</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/clientexunidade"
                                                         tag="li"
                                                         v-if="getPermission('clienteunidade.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Cliente X Unidade</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/ncm"
                                                         tag="li"
                                                         v-if="getPermission('ncm.index')">
                                                <a>
                                                    <span class="list-group-item no-border">NCM</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/onu"
                                                         tag="li"
                                                         v-if="getPermission('onu.index')">
                                                <a>
                                                    <span class="list-group-item no-border">ONU</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/parammotivo"
                                                         tag="li"
                                                         v-if="getPermission('parammotivo.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Motivos</span>
                                                </a>
                                            </router-link>

                                          <router-link to="/unidadeparceira"
                                                       tag="li"
                                                       v-if="getPermission('unidadeparceira.index')">
                                            <a>
                                              <span class="list-group-item no-border">Unidade Parceira</span>
                                            </a>
                                          </router-link>

                                        </template>
                                    </dropdown>

                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn"><span class="list-group-item no-border">Aquaviário</span></template>
                                        <template slot="body">
                                            <router-link to="/porto"
                                                         tag="li"
                                                         v-if="getPermission('porto.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Portos / Terminais</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/embarcacao"
                                                         tag="li"
                                                         v-if="getPermission('embarcacao.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Embarcação</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtipoembarcacao"
                                                         tag="li"
                                                         v-if="getPermission('paramtipoembarcacao.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Embarcação</span>
                                                </a>
                                            </router-link>

                                        </template>
                                    </dropdown>

                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn"><span class="list-group-item no-border">Rodoviário</span></template>
                                        <template slot="body">
                                            <router-link to="/veiculo"
                                                         tag="li"
                                                         v-if="getPermission('veiculo.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Veículo</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/motorista"
                                                         tag="li"
                                                         v-if="getPermission('motorista.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Motorista</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtiporodado"
                                                         tag="li"
                                                         v-if="getPermission('paramtiporodado.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Rodado</span>
                                                </a>
                                            </router-link>
                                            <router-link to="/paramtipocombustivel"
                                                         tag="li"
                                                         v-if="getPermission('paramtipocombustivel.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Combustível</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/marcaveiculo"
                                                         tag="li"
                                                         v-if="getPermission('marcaveiculo.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Marca veículo</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/corveiculo"
                                                         tag="li"
                                                         v-if="getPermission('corveiculo.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Cor veículo</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtipocarroceria"
                                                         tag="li"
                                                         v-if="getPermission('paramtipocarroceria.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Carroceria</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtipoproprietario"
                                                         tag="li"
                                                         v-if="getPermission('paramtipoproprietario.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Proprietário</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtipoveiculo"
                                                         tag="li"
                                                         v-if="getPermission('paramtipoveiculo.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Veículo</span>
                                                </a>
                                            </router-link>
                                        </template>
                                    </dropdown>

                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn"><span class="list-group-item no-border">EDI</span></template>
                                        <template slot="body">
                                            <router-link to="/pessoainterface"
                                                         tag="li"
                                                         v-if="getPermission('pessoainterface.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Parametrização Cliente</span>
                                                </a>
                                            </router-link>

                                          <router-link to="/interfacegateway"
                                                       tag="li"
                                                       v-if="getPermission('interfacegateway.index')">
                                            <a>
                                              <span class="list-group-item no-border">Parametrização Interface</span>
                                            </a>
                                          </router-link>

                                            <router-link to="/blayout"
                                                         tag="li"
                                                         v-if="getPermission('blayout.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Layout</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/blayoutgrupo"
                                                         tag="li"
                                                         v-if="getPermission('blayoutgrupo.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Layout Grupo</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/barquivo"a
                                                         tag="li"
                                                         v-if="getPermission('barquivo.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Arquivo</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/bgrupodados"
                                                         tag="li"
                                                         v-if="getPermission('bgrupodados.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Grupo de dados</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/layout"
                                                         tag="li"
                                                         v-if="getPermission('layout.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Layout</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/importacaodocedi"
                                                         tag="li"
                                                         v-if="getPermission('importacaodocedi.importar')">
                                                <a>
                                                    <span class="list-group-item no-border">Importação doc.</span>
                                                </a>
                                            </router-link>

                                        </template>
                                    </dropdown>

                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn"><span class="list-group-item no-border">Cliente</span></template>
                                        <template slot="body">
                                            <router-link to="/pessoa"
                                                         tag="li"
                                                         v-if="getPermission('pessoa.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Cliente</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/seguradora"
                                                         tag="li"
                                                         v-if="getPermission('seguradora.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Seguradora</span>
                                                </a>
                                            </router-link>

                                        </template>
                                    </dropdown>

                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn"><span class="list-group-item no-border">Frete</span></template>
                                        <template slot="body">
                                            <router-link to="/regiao"
                                                         tag="li"
                                                         v-if="getPermission('regiao.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Região</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/transptpcalc"
                                                         tag="li"
                                                         v-if="getPermission('transptpcalc.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Parâmetro de cálculo</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramocorrencia"
                                                         tag="li"
                                                         v-if="getPermission('paramocorrencia.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Parâmetro de Ocorrência</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramocorrenciadestino"
                                                         tag="li"
                                                         v-if="getPermission('paramocorrenciadestino.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Parâmetro de Ocorrência Destino</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramocorrenciaorigem"
                                                         tag="li"
                                                         v-if="getPermission('paramocorrenciaorigem.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Parâmetro de Ocorrência Origem</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/tabelafrete"
                                                         tag="li"
                                                         v-if="getPermission('tabelafrete.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tabela de Frete</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/gradedecoletaentrega"
                                                         tag="li"
                                                         v-if="getPermission('gradecoletaentrega.index')"
                                                        >
                                                <a>
                                                    <span class="list-group-item no-border">Grade de Coleta e Entrega</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/custo"
                                                         tag="li"
                                                         v-if="getPermission('custo.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Custo</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/tipocarga"
                                                         tag="li"
                                                         v-if="getPermission('tipocarga.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Carga</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtipocarga"
                                                         tag="li"
                                                         v-if="getPermission('paramtipocarga.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Parâmetro de Tipo Carga</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtiporateio"
                                                         tag="li"
                                                         v-if="getPermission('paramtiporateio.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Rateio</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtipocusto"
                                                         tag="li"
                                                         v-if="getPermission('paramtipocusto.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Custo</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/modelocte"
                                                         tag="li"
                                                         v-if="getPermission('modelocte.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Modelo CTE</span>
                                                </a>
                                            </router-link>
                                            <router-link to="/simulacaocalculofrete"
                                                         tag="li"
                                                         v-if="getPermission('simulacaocalculofrete.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Simulação calculo frete</span>
                                                </a>
                                            </router-link>
                                        </template>
                                    </dropdown>

                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn"><span class="list-group-item no-border">Parâmetros</span></template>
                                        <template slot="body">
                                            <router-link to="/paramendereco"
                                                         tag="li"
                                                         v-if="getPermission('paramendereco.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Endereço</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtipomedida"
                                                         tag="li"
                                                         v-if="getPermission('paramtipomedida.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Medida</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramunidademedida"
                                                         tag="li"
                                                         v-if="getPermission('paramunidademedida.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Unidade Medida</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtiporespseg"
                                                         tag="li"
                                                         v-if="getPermission('paramtiporespseg.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Responsável Seguro</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtipoemail"
                                                         tag="li"
                                                         v-if="getPermission('paramtipoemail.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Email</span>
                                                </a>
                                            </router-link>
                                            <router-link to="/paramocupacao"
                                                         tag="li"
                                                         v-if="getPermission('paramocupacao.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Ocupação</span>
                                                </a>
                                            </router-link>
                                            <router-link to="/paramnacionalidade"
                                                         tag="li"
                                                         v-if="getPermission('paramnacionalidade.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Nacionalidade</span>
                                                </a>
                                            </router-link>
                                            <router-link to="/paramestadocivil"
                                                         tag="li"
                                                         v-if="getPermission('paramestadocivil.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Estado Civil</span>
                                                </a>
                                            </router-link>
                                            <router-link to="/paramrelacionamento"
                                                         tag="li"
                                                         v-if="getPermission('paramrelacionamento.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Relacionamento</span>
                                                </a>
                                            </router-link>
                                            <router-link to="/paramtipoarea"
                                                         tag="li"
                                                         v-if="getPermission('paramtipoarea.index')">
                                              <a>
                                                <span class="list-group-item no-border">Tipo de Área</span>
                                              </a>
                                            </router-link>
                                            <router-link to="/paramtiposervico"
                                                         tag="li"
                                                         v-if="getPermission('paramtiposervico.index')"
                                                         >
                                                <a>
                                                    <span class="list-group-item no-border">Tipo de Serviço</span>
                                                </a>
                                            </router-link>

                                        </template>
                                    </dropdown>

                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn"><span class="list-group-item no-border">Fiscal</span></template>
                                        <template slot="body">

                                            <router-link to="/icms"
                                                         tag="li"
                                                         v-if="getPermission('icms.index')">
                                                <a>
                                                    <span class="list-group-item no-border">ICMS</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/municipioiss"
                                                         tag="li"
                                                         v-if="getPermission('municipioiss.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Alíquotas ISS</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/cfop"
                                                         tag="li"
                                                         v-if="getPermission('cfop.index')">
                                                <a>
                                                    <span class="list-group-item no-border">CFOP</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/cfopregra"
                                                         tag="li"
                                                         v-if="getPermission('cfopregra.index')">
                                              <a>
                                                <span class="list-group-item no-border">Regras CFOP</span>
                                              </a>
                                            </router-link>

                                            <router-link to="/paramcategoriacfop"
                                                         tag="li"
                                                         v-if="getPermission('paramcategoriacfop.index')">
                                              <a>
                                                <span class="list-group-item no-border">Categoria CFOP</span>
                                              </a>
                                            </router-link>

                                            <router-link to="/cnae"
                                                         tag="li"
                                                         v-if="getPermission('cnae.index')">
                                                <a>
                                                    <span class="list-group-item no-border">CNAE</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramcst"
                                                         tag="li"
                                                         v-if="getPermission('paramcst.index')">
                                                <a>
                                                    <span class="list-group-item no-border">CST</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/regrafiscal"
                                                         tag="li"
                                                         v-if="getPermission('regrafiscal.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Regras Fiscais</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/paramtipodoc"
                                                         tag="li"
                                                         v-if="getPermission('paramtipodoc.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Tipo Documento</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/contacontabil"
                                                         tag="li"
                                                         v-if="getPermission('contacontabil.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Contas Contábeis</span>
                                                </a>
                                            </router-link>

                                            <router-link to="/centrocusto"
                                                         tag="li"
                                                         v-if="getPermission('centrocusto.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Centro de Custo</span>
                                                </a>
                                            </router-link>
                                        </template>
                                    </dropdown>

                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn"><span class="list-group-item no-border">Financeiro</span></template>
                                        <template slot="body">
                                            <router-link to="/parambanco"
                                                         tag="li"
                                                         v-if="getPermission('parambanco.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Bancos</span>
                                                </a>
                                            </router-link>
                                        </template>
                                    </dropdown>

                                    <dropdown :trigger="'hover'"
                                              :role="'sublist'"
                                              :align="'right'"
                                              :close-on-click="true">
                                        <template slot="btn"><span class="list-group-item no-border">Conferência</span></template>
                                        <template slot="body">
                                            <router-link to="/pallet"
                                                         tag="li"
                                                         v-if="getPermission('pallet.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Pallets</span>
                                                </a>
                                            </router-link>
                                            <router-link to="/area"
                                                         tag="li"
                                                         v-if="getPermission('area.index')">
                                                <a>
                                                    <span class="list-group-item no-border">Áreas</span>
                                                </a>
                                            </router-link>
                                        </template>
                                    </dropdown>
                                </ul>
                            </template>
                        </dropdown>

                        <dropdown :close-on-click="true"
                                  class="p-1"
                                  v-if="getPermission('acessos.menu')"
                                  >
                            <template slot="btn">
                                <i class="fa fa-key"></i>&nbsp;<span class="bp-dropdown__btn">Acessos</span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/usuario"
                                                         tag="li"
                                                         v-if="getPermission('usuario.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-users'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Usuários</p>
                                                                <small>Gerenciamento de usuários</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/unidade"
                                                         tag="li"
                                                         v-if="getPermission('unidade.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-underline'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Unidades</p>
                                                                <small>Gerenciamento de unidades</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/integracao"
                                                         tag="li"
                                                         v-if="getPermission('integracao.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='fa fa-cogs'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Integrações</p>
                                                                <small>Gerenciamento de Integrações</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/role"
                                                         tag="li"
                                                         v-if="getPermission('role.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-unlock'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Roles / Perfil</p>
                                                                <small>Gerenciamento de perfils de usuário</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/ftp"
                                                         tag="li"
                                                         v-if="getPermission('ftp.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-unlock'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">FTP</p>
                                                                <small>Gerenciamento conexões FTP</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/monitorprocesso"
                                                         tag="li"
                                                         v-if="getPermission('monitorprocesso.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-tv'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Monitor de processos</p>
                                                                <small>Monitoramento de processos automáticos</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/monitorcte"
                                                         tag="li"
                                                         v-if="getPermission('monitorcte.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-tv'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Monitor de CTE</p>
                                                                <small>Monitora integração de CTE</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/permission"
                                                         tag="li"
                                                         v-if="getPermission('permission.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-toggle-right'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Permissões</p>
                                                                <small>Cadastro e manutenção de permissões</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/listitemvalor"
                                                         tag="li"
                                                         v-if="getPermission('listitemvalor.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-tag'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Lista de valores</p>
                                                                <small>Lista de valores do sistema</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link to="/bmodal"
                                                         tag="li"
                                                         v-if="getPermission('bmodal.index') && b_plano.is_free==2">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-target'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Modal</p>
                                                                <small>Cadastro de modais</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown>
                        <dropdown :close-on-click="true"
                                  class="p-1"
                                  v-if="getPermission('conferencia.menu')"
                                  >
                            <template slot="btn">
                                <i class="fa fa-calculator"></i>&nbsp;<span class="bp-dropdown__btn">Conferência</span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/auditoria"
                                                         tag="li"
                                                         v-if="getPermission('auditoria.index')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-tv'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Auditoria</p>
                                                                <small>Monitoramento de processos automáticos</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/associardocumentodespesa"
                                                         tag="li"
                                                         v-if="getPermission('associardocumentodespesa.associar')">
                                                <a>
                                                    <span class="list-group-item">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class='ft-tv'></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Associar Documento </p>
                                                                <small>Associação de documentos despesa</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown>
                        <dropdown :close-on-click="true"
                                  class="p-1"
                                  v-if="getPermission('relatorio.index')">
                            <template slot="btn">
                                <i class='fa fa-wpforms'></i>&nbsp;<span class="bp-dropdown__btn">Relatorios</span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/posicaofrete"
                                                         tag="li">
                                                <a>
                                                    <span class="list-group-item">
                                                        Posição de Frete
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/extracaotabelafrete"
                                                         tag="li">
                                                <a>
                                                    <span class="list-group-item">
                                                        Extração de Tabela de Frete
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <a href="https://madeiramadeira.sa.looker.com/looks/6746" target="_blank">
                                                <span class="list-group-item">
                                                    Cargas Liberadas com Divergencias
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <a href="https://madeiramadeira.sa.looker.com/looks/6748" target="_blank">
                                                <span class="list-group-item">
                                                    Volume Expedido
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/veiculos"
                                                         tag="li">
                                                <a>
                                                    <span class="list-group-item">
                                                        Veiculos
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/proprietarioveiculo"
                                                         tag="li">
                                                <a>
                                                    <span class="list-group-item">
                                                        Proprietario Veiculo
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <a href="https://madeiramadeira.sa.looker.com/looks/6772" target="_blank">
                                                <span class="list-group-item">
                                                    MDFE
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/freteportransportadora"
                                                         tag="li">
                                                <a>
                                                    <span class="list-group-item">
                                                        Frete por Transportadora
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <a href="https://madeiramadeira.sa.looker.com/looks/6750" target="_blank">
                                                <span class="list-group-item">
                                                    Gerenciamento Frete
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/relatoriofaturareceita"
                                                         tag="li">
                                                <a>
                                                    <span class="list-group-item">
                                                        Pré-Fatura-Receita
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                  <div class="col-sm-12 col-md-12">
                                    <div class="list-group list-group-flush">
                                        <a href="https://madeiramadeira.sa.looker.com/looks/6773" target="_blank">
                                            <span class="list-group-item">
                                                 Pré-Fatura-Despesa
                                            </span>
                                        </a>
                                    </div>
                                  </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/freterecebidoexpedido"
                                                         tag="li">
                                                <a>
                                                    <span class="list-group-item">
                                                        Frete Recebido/Expedido
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-a-0">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="list-group list-group-flush">
                                            <a href="https://madeiramadeira.sa.looker.com/looks/6749" target="_blank">
                                                <span class="list-group-item">
                                                    Fatura
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                              <div class="row m-a-0">
                                <div class="col-sm-12 col-md-12">
                                  <div class="list-group list-group-flush">
                                      <a href="https://madeiramadeira.sa.looker.com/looks/6747" target="_blank">
                                        <span class="list-group-item">
                                            Notas fiscais canceladas
                                        </span>
                                      </a>
                                  </div>
                                </div>
                              </div>
                              <div class="row m-a-0">
                                <div class="col-sm-12 col-md-12">
                                  <div class="list-group list-group-flush">
                                    <router-link to="/errosbip"
                                                 tag="li">
                                      <a>
                                        <span class="list-group-item">
                                            Erros Bip
                                        </span>
                                      </a>
                                    </router-link>
                                  </div>
                                </div>
                              </div>
                              <div class="row m-a-0">
                                <div class="col-sm-12 col-md-12">
                                  <div class="list-group list-group-flush">
                                    <router-link to="/adiantamento"
                                                 tag="li">
                                      <a>
                                        <span class="list-group-item">
                                            Adiantamento
                                        </span>
                                      </a>
                                    </router-link>
                                  </div>
                                </div>
                              </div>
                            </template>
                        </dropdown>

                        <!-- TODO: Mostrar o dropdown apenas quando a unidade tiver a oc ativa -->
                        <dropdown
                            id="menu-ordem-coleta"
                            :close-on-click="true"
                            v-if="getPermission('gerarordemcoleta.index')"
                            class="p-1"
                        >
                            <template slot="btn">
                                <i class="ft-box"></i>&nbsp;<span class="bp-dropdown__btn">
                                    Ordem de Coleta
                                </span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12">
                                        <div class="list-group list-group-flush">
                                            <router-link
                                                to="/gerarordemcoleta"
                                                v-if="getPermission('gerarordemcoleta.index')"
                                            >
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class="ft-plus"></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Gerar</p>
                                                                <small>Gerar Ordem de Coleta</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                            <router-link
                                                to="/ordemcoleta"
                                                v-if="getPermission('ordemcoleta.index')"
                                            >
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div class="media">
                                                            <div class="mr-1">
                                                                <i class="ft-list"></i>
                                                            </div>
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Ordens de Coleta</p>
                                                                <small>Lista de Ordens de Coleta</small>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown>

                        <dropdown id="menu-operacao"
                                  :close-on-click="true"
                                  v-show="getPermission('inventario.index') && conference_module"
                                  class="p-1 text-muted">
                            <template slot="btn">
                                <i class="fa fa-book"></i>&nbsp;<span class="bp-dropdown__btn">Módulo PNC/Invetário</span>
                            </template>
                            <template slot="body">
                                <div class="row m-a-0">
                                    <div class="col-sm-12">
                                        <div class="list-group list-group-flush">
                                            <router-link to="/inventario" tag="li">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div @click="closeMenuMobile()" class="media">
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">PNC Consulta</p>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>

                                            <router-link to="/inventario/gestao" tag="li">
                                                <a>
                                                    <span class="list-group-item no-border">
                                                        <div  @click="closeMenuMobile()" class="media">
                                                            <div class="media-body">
                                                                <p class="mt-0 mb-0">Gestão de Inventário</p>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="b_plano.is_free==1" class="m-t alert alert-warning alert-no-border alert-close alert-dismissible fade show m-1" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <h1>Atenção</h1>
            <p>Você está usando o plano gratuito do BLogistic, você ainda tem direito a emitir {{b_plano.qtde_cte}} CTes, {{b_plano.qtde_mdfe}} MDFes e pode cadastrar {{b_plano.qtde_unidade}} unidade(s)</p>
        </div>

        <div v-if="!certificado_instalado" class="m-t alert alert-warning alert-no-border alert-close alert-dismissible fade show m-1" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            Atenção, não há certificado A1 configurado para emissão do CTE. Favor configurar na tela de configurações da conta
        </div>

        <b-modal id="modal_form"
                 ref="modal_form"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 cancel-title="Cancelar"
                 :no-close-on-backdrop="true"
                 :no-close-on-esc="true"
                 :ok-disabled=helpForm.errors.any()
                 v-model="showModalToken"
                 @ok="handleOk">

            <form @submit.stop.prevent="handleOk" @keydown="helpForm.errors.clear($event.target.name)">
                <div v-if="metodo_primario">
                    <b-form-text>Favor informar o token enviado</b-form-text>
                    <b-form-input type="text"
                                 placeholder="Token"
                                 v-model="helpForm.token_primario"
                                 size="sm">
                    </b-form-input>
                    <b-form-feedback v-text="helpForm.errors.get('token_primario')" v-if="helpForm.errors.has('token_primario')"></b-form-feedback>
                    <br/>
                </div>

                <div v-if="metodo_secundario">
                    <b-form-text>Favor informar o token enviado no método alternativo</b-form-text>
                    <b-form-input type="text"
                                 placeholder="Token"
                                 v-model="helpForm.token_secundario"
                                 size="sm">
                    </b-form-input>
                    <b-form-feedback v-text="helpForm.errors.get('token_secundario')" v-if="helpForm.errors.has('token_secundario')"></b-form-feedback>
                    <br/>
                </div>
                Não recebeu o token ? <br/>

                <b-btn v-if="metodo_primario" @click="handleReenviarToken($event)" variant="primary" :disabled="isDisabled">
                  Reenviar TOKEN
                </b-btn>
                <b-btn v-if="metodo_primario" @click="handleEnviarAlternativo($event)" variant="primary" :disabled="isDisabled">
                  Utilizar método alternativo
                </b-btn>
                <b-btn v-if="metodo_secundario" @clicl="handleMetodoPrimario($event)" variant="primary" :disabled="isDisabled">
                  Utilizar método principal
                </b-btn>

            </form>
            <div slot="modal-footer" class="w-100">
                 <div class="float-left"><spinner v-if="loading" message="Autorizando..."></spinner>
                 </div>
                 <div class="float-right">
                     <b-btn @click="handleOk($event)" variant="primary" :disabled="isDisabled">
                       Autorizar
                     </b-btn>
                 </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { setUserData } from '../utils';
import Dropdown from './Dropdown';
    import Notification from './Notification';
    import moment from 'moment'

    export default {
        components: {
            Dropdown,
            Notification
        },
        data() {
            return {
                site_header_color: 'navbar navbar-expand-lg navbar-light border-bottom',
                site_header: 'bg-white',
                showModalToken: false,
                loading: false,
                isDisabled: false,
                metodo_primario: true,
                metodo_secundario: false,
                isSmallScreen: false,
                isMenuShowHide: true,
                url_img_profile: '',
                ramal: [{
                    nome: '',
                    telefone: '',
                    tipo_tel: ''
                }],
                modal_titulo: 'Token',
                modal_botao: 'Autorizar',
                helpForm: new Form({
                    unidade_id: '',
                    bcliente_id: '',
                    token_primario: '',
                    token_secundario: '',
                    nome: ''
                }),
                window: {
                  width: 0,
                  height: 0
              },
            }
        },
        mounted() {
          this.getUserData();
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        methods: {
            handleResize() {
                 this.window.width = window.innerWidth;
                 this.window.height = window.innerHeight;
                 if(this.window.width>=600)
                 {
                     this.isSmallScreen = false;
                 }
                 else
                 {
                     this.isMenuShowHide = false;
                     this.isSmallScreen = true;
                 }
            },
            closeMenuMobile(){
                if(window.innerWidth <= 600){
                    this.isMenuShowHide = false;
                }
            },
            destroyed() {
                window.removeEventListener('resize', this.handleResize)
            },
            formatDate(value, fmt = 'DD/MM/YYYY HH:mm') {
                return (value == null) ?
                    '' :
                    moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
            },
            menuShowHide() {
                this.isMenuShowHide = !this.isMenuShowHide;
            },
          getUserData() {
            this.helpForm.get('/api/usuario').then(resp => {
              if (resp.user.status_login == 2) {
                this.showModalToken = true;
              } else {
                this.$store.commit('setApiVersion', resp.user.unidade_active.api_version);
                this.$store.commit('setBcliente', resp.user.bcliente_active);
                this.$store.commit('setUser', resp);
                if (this.$store.getters.logged.user.unidade_active != undefined) {
                  this.$store.commit('setUnidade', resp.user.unidade_active);
                } else {
                  this.$store.commit('setUnidade', null);
                }
                if (resp.user.bcliente_active.b_config_blogistic.cor_sistema == "1") {
                  this.site_header_color = "";
                } else if (resp.user.bcliente_active.b_config_blogistic.cor_sistema == "2") {
                  this.site_header_color = "site-header-red";
                } else if (resp.user.bcliente_active.b_config_blogistic.cor_sistema == "3") {
                  this.site_header_color = "site-header-blue";
                }
                this.$store.commit('BPlano', resp.user.bcliente_active.b_bcliente_bplano);
                this.favorito = resp.favorito;
                this.tarefa = resp.tarefa;
                this.changelog = resp.changelog;
                if (resp.user.pessoa_fisica !== null) {
                  if (resp.user.pessoa_fisica == null) {
                    this.url_img_profile = "images/avatar/avatar-1-32.png";
                  } else {
                    this.url_img_profile = resp.user.pessoa_fisica.url_img;
                  }
                } else {
                  this.url_img_profile = "images/avatar/avatar-1-32.png";
                }
              }
            })
                .catch(errors => {
                  new ReturnApi(errors, this)
                });
          },
            logout(){
              alert('Logout Realizado com sucesso');
              this.helpForm.post('/api/usuario/logout').then(resp => {
              }).catch(errors => {
                    new ReturnApi(errors, this)
                  });
              window.location.href = "/";
            },
            checkAuth() {
                this.helpForm.post('/api/usuario/checkAuth').then(resp => {})
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            setUnidadeInterno(unidade_id) {
                this.helpForm.unidade_id = unidade_id;
                this.helpForm.post('/api/usuario/alteraunidade').then(response => {
                        new ReturnApi(response, this, true, false, true);
                    setUserData(this.$store);
                        window.location = "/#/dashboard";
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            setBclienteInterno(bcliente_id) {
                this.helpForm.bcliente_id = bcliente_id;
                this.helpForm.post('/api/usuario/alterabcliente').then(response => {
                    setUserData(this.$store);
                  window.location = "/#/dashboard";

                })
                .catch(errors => {
                    new ReturnApi(errors, this)
                });
            },
            getPermission(checkPermission) {
                return this.getPermissionFw(checkPermission);
            },
            doCollapse(e) {
                e.stopPropagation();
                e.preventDefault();
            },
            doRamal(e) {
                e.stopPropagation();
                e.preventDefault();
                this.ramal = null;
                this.ramal = [];
                this.loading = true;
                this.isDisabled = true;
                this.helpForm.post('/api/usuario/ramal').then(response => {
                        response.forEach((obj) => {
                            obj.pessoa.pessoa_contato_tel.forEach((obj2) => {
                                this.ramal.push({
                                    nome: obj.nome,
                                    telefone: obj2.telefone
                                })
                            });
                        });

                        this.loading = false;
                        this.isDisabled = false;
                        new ReturnApi(response, this, true, false, true);
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            handleOk(e) {
                this.loading = true;
                this.isDisabled = true;
                e.preventDefault();
                this.helpForm.post('/api/usuario/token/check').then(response => {
                        if (response.status_token == 1) {
                            this.showModalToken = false;
                            new ReturnApi(response, this, true, false, true);
                            setUserData(this.$store);
                        } else {
                            this.loading = false;
                            this.isDisabled = false;
                            new ReturnApi(response, this, true, false, true);
                        }
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            handleReenviarToken(e) {
                this.loading = true;
                this.isDisabled = true;
                this.metodo_primario = true;
                this.metodo_secundario = false;
                e.preventDefault();
                this.helpForm.post('/api/usuario/token/reenviar').then(response => {
                        this.loading = false;
                        this.isDisabled = false;
                        new ReturnApi(response, this, true, false, true);
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            handleEnviarAlternativo(e) {
                this.loading = true;
                this.isDisabled = true;
                this.metodo_primario = false;
                this.metodo_secundario = true;
                e.preventDefault();
                this.helpForm.post('/api/usuario/token/alternativo').then(response => {
                        this.loading = false;
                        this.isDisabled = false;
                        new ReturnApi(response, this, true, false, true);
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            handleMetodoPrimario(e) {
                this.metodo_primario = true;
                this.metodo_secundario = false;
            }
        },
        computed: {
            width: {
                get() {
                    return this.window.width;
                }
            },
            user: {
                get() {
                    return this.$store.state.logged.user;
                }
            },
            unidades: {
                get() {
                    return this.$store.getters.unidades;
                }
            },
            unidade_active: {
                get() {
                    return this.$store.getters.unidade_active;
                }
            },
            conference_module: {
              get() {
                return this.$store.getters.unidade_active.utiliza_modulo_conferencia;
              }
            },
            b_plano: {
                get() {
                    return this.$store.getters.bplano;
                }
            },
            bclientes: {
                get() {
                    return this.$store.getters.logged.bclientes;
                }
            },
            isLoaded: {
                get() {
                    return this.$store.getters.isloaded;
                }
            },
            bcliente_active: {
                get() {
                    return this.$store.getters.bcliente_active;
                }
            },
            certificado_instalado: {
                get() {
                    return this.$store.getters.certificado_instalado;
                }
            },
            logo: {
              get () {
                return process.env.VUE_APP_LOGO_MINI;
              },
            },
        }
    }

</script>
<style>
@media(max-width:500px){
 #navbar{
    margin-bottom: 50px;
 }
}
</style>
